/* APLICAR DESCUENTOS DESDE LA URL 							*/
/*
  let params = new URLSearchParams(window.location.search);let promocode = params.get('promocode'); 
if (promocode) { 
  	var urll = '/discount/' + promocode;
  	fetch(urll)  	
  	.then(data => console.log(data));  
}
*/

/****************************************************************/
/* COMPROBAR COOKIES TERMS HUB   							    */
/****************************************************************/
document.addEventListener("change", async function (event) {
  var input = event.target.closest(".product-item-meta__swatch-list .color-swatch__radio");
  if (!input) return;

  var productItem = input.closest("product-item");
  if (!productItem) return;

  var slider = productItem.querySelector(".product-item__plp-slider");
  if (!slider || !slider.flickityInstance) return;

  var featuredMediaId = input.getAttribute("data-variant-featured-media");
  if (!featuredMediaId) return;

  var targetCell = slider.querySelector('[data-media-id="' + featuredMediaId + '"]');
  if (!targetCell) return;

  var flickity = await slider.flickityInstance;
  flickity.selectCell(targetCell);
});

var conset_data = false;

function buscar_cookie() {
  var nombreTermsHub = "termshub-consent=";
  var ca = document.cookie.split(';');
  var cookie_obj = "";  
  
  for(var i=0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nombreTermsHub) == 0) cookie_obj = JSON.parse(c.substring(nombreTermsHub.length,c.length));      
  }

  return cookie_obj;
}
  
function inicializar() {
  var cookie_obj = buscar_cookie();

  console.log("ENTRA");      
  // Define dataLayer and the gtag function.
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  gtag('js', new Date());
  gtag('config', 'G-D2ZGVP6PVD');    
  
  if (cookie_obj == "") {    
    console.log("NO COOKIES");      
    // Set default consent to 'denied' as a placeholder    
    gtag('consent', 'default', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    });  

    gtag('consent', 'update', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    });    
    
  } else if (cookie_obj.categories) {      
    var necessary_val = cookie_obj.categories.necessary.wanted ? 'granted' : 'denied';    
    var analytics_val = cookie_obj.categories.statistics.wanted ? 'granted' : 'denied';
    var functional_val = cookie_obj.categories.functional.wanted ? 'granted' : 'denied';
    var ads_val = cookie_obj.categories.marketing.wanted ? 'granted' : 'denied';
    gtag('consent', 'update', {
      'ad_storage': ads_val,
      'ad_user_data': ads_val,
      'ad_personalization': ads_val,
      'analytics_storage': analytics_val
    });     
  }  
}

function consent_check() {
  var cookie_obj = buscar_cookie();
  
  if (cookie_obj.categories) {    
    var necessary_val = cookie_obj.categories.necessary.wanted ? 'granted' : 'denied';    
    var analytics_val = cookie_obj.categories.statistics.wanted ? 'granted' : 'denied';
    var functional_val = cookie_obj.categories.functional.wanted ? 'granted' : 'denied';
    var ads_val = cookie_obj.categories.marketing.wanted ? 'granted' : 'denied';
    gtag('consent', 'update', {
      'ad_storage': ads_val,
      'ad_user_data': ads_val,
      'ad_personalization': ads_val,
      'analytics_storage': analytics_val
    });     
    conset_data = true;
  }  
}

// Función para verificar si se ha modificado una cookie
function verificarCambiosEnCookies(callback) {
    // Guardar una copia del estado actual de las cookies
    var cookiesAnteriores = document.cookie;

    // Establecer un intervalo de tiempo para verificar continuamente los cambios en las cookies
    setInterval(function() {
        // Obtener el estado actual de las cookies
        var cookiesActuales = document.cookie;

        // Verificar si ha habido cambios en las cookies
        if (cookiesActuales !== cookiesAnteriores) {            
            // Ejecutar la función de callback cuando se detecte un cambio
            callback();
            // Actualizar el estado de las cookies para la próxima comparación
            cookiesAnteriores = cookiesActuales;
        }
    }, 1000); // Intervalo de verificación (en milisegundos)
}

inicializar();
// Llamar a la función para verificar cambios en las cookies
verificarCambiosEnCookies(consent_check);